import styled from "styled-components";

export const LinkStyled = styled.a`
  color: #5664FC;
  text-decoration: underline;

  &:hover {
    color: #F61067;
    text-decoration: none;
  }

  &:link, &:visited {
    color: #5664FC;
    text-decoration: underline;
  }
`